import http from "../httpcommon";
import httpcommon from "../httpCommon1";

const BASE_URL = process.env.REACT_APP_NEW_BASEURL || '';

class ProfileServices {
  getDataAPI(id) {
    if (!id) {
      return Promise.reject(new Error('ID is required'));
    }
    
    const payload = { code: id };
    return httpcommon.post('dropdown/user/code', payload);
  }

  getStateList() {
    return httpcommon.get('dropdown/state/list');
  }

  updateUserdata(payload) {
    if (!payload?.id) {
      return Promise.reject(new Error('User ID is required for update'));
    }
    
    return http.put(`user/${payload.id}`, payload);
  }

  getUserConsentData(payload) {
    const { status, userId } = payload || {};
    
    if (!status || !userId) {
      return Promise.reject(new Error('Status and userId are required'));
    }
    
    const encodedStatus = encodeURIComponent(status);
    const encodedUserId = encodeURIComponent(userId);
    
    const url = `${BASE_URL}UserConsent/list/filter?status=${encodedStatus}&userId=${encodedUserId}`;
    return http.get(url);
  }

  updateUserConsent(payload) {
    if (!payload) {
      return Promise.reject(new Error('Payload is required'));
    }
    
    const url = `${BASE_URL}PatientConsent/addPatientConsent`;
    return http.post(url, payload);
  }
}

export default new ProfileServices();